export default __webpack_public_path__ + "static/media/avatar-mp-1-2.63d87f57.png";